export default __webpack_public_path__ + "static/media/about-us-banner.df0b566c.webp";